import {gsap} from 'gsap';
import * as Hammer from 'hammerjs';
import { throttle } from 'throttle-debounce';
import emitter from 'tiny-emitter/instance';
import { debounce } from 'throttle-debounce';
export default class DragSlider{


  constructor(el,opts = {})
  {
    // declare values`
    this.el = el
    this.slide =  this.el.querySelectorAll("[data-dragSlider='slider']")
    this.inner = this.el.querySelector("[data-dragSlider='inner']")
    this.rafId = null
    // first declaration of hammer for the drag slider
    this.hammer = null

    //drag index counter
    this.displayCurrentIndex = this.el.querySelector("[data-dragSlider='current']")
    this.total = this.el.querySelector("[data-dragSlider='total']")

    this.progressBar = this.el.querySelector("[data-dragSlider='indicator--inner']");
    this.progressWrap = this.el.querySelector("[data-dragSlider='indicator']");
    this.dragIndex = this.el.querySelector("[data-dragSlider='index']")
    this.lastDeltaX = 0 // stock last delta pos
    this.navButtons = this.el.querySelector('.newsSlider-nav nav')

    this.itemWidth = (this.slide[0]) ? this.slide[0].offsetWidth : 0
    // options properties
    this.el.opts = {
      scrollSpeed : opts.scrollSpeed || 3, // number between 1 & XXX
      inertiaSpeed : opts.inertiaSpeed || 1,
      getSlide : opts.getSlide,  // boolean
      draggableBar : opts.draggableBar, // boolean
      arrowBtnDirection : opts.arrowBtnDirection
    }

    // add movement method
    this.handleMove = () => {
      this.detectSlide()
    }
    this.debouncedHandleMove = throttle(100,false, this.handleMove);

    this.debounceLimiter = debounce(150, false, this.checkLimitSlider.bind(this));

    this.startX
    this.limit
    this.sliderTranslate  = 0
    this.dragSlidePercent
    this.dragIndicatorPercent
    this.innerX = 0;
    this.progressBarX = 0;
    this.isLimitSlidePercent = false

    this.innerWidth
    this.visibleWidth

    this.progressWrapWidth
    this.progressBarWidth //= this.progressBar.getBoundingClientRect().width // get progress bar width
    // second declaration of hammer for the drag indicator
    this.StartIndicatorX
    this.indicatorTranslate = 0
    this.limitIndicator
    this.indicatorState = false

    // on va faire nos petit quicksetter pour l'opti
    this.progressBarSetterX =  gsap.quickSetter(this.progressBar, 'x', 'px');
    this.innerSetterX =  gsap.quickSetter(this.inner, 'x', 'px');

    this.stopped = true

    this.options()
    this.setup()
    this.bindEvents()

  }

  options()
  {

    if (this.el.opts.getSlide) {
      this.index()
      this.detectSlide()
    } else {
      if (this.dragIndex !== null) {
        this.dragIndex.style.display = 'none'
      }
    }

    //remove progressbar
    if (this.el.opts.draggableBar) {
      this.progressWrapWidth = this.progressWrap.getBoundingClientRect().width // get wrap width
    } else {
      if (this.progressWrap !== null) {
        this.progressWrap.style.display = 'none'
      }
    }
  }

  //
  setup()
  {
    // limit of the drag slider
    this.visibleWidth = this.el.getBoundingClientRect().width
    this.innerWidth = this.inner.getBoundingClientRect().width

    this.limit = this.visibleWidth - this.innerWidth
    // console.log(this.visibleWidth, this.innerWidth)

    this.displayControls()

    // update slider max value on resize
    if (this.sliderTranslate <= this.limit) {
      this.sliderTranslate = this.limit

      // setup progress bar width & apply this width
      this.progressBarWidth = (this.visibleWidth / this.innerWidth) * this.progressWrapWidth
      if (this.progressBar !== null) {
        this.progressBar.style.width = `${this.progressBarWidth}px`
      }

      // limit of the drag slider indicator
      this.limitIndicator = this.progressWrapWidth - this.progressBarWidth

      // on va regarder si on a besoin du slider, si la limite faut 0 ca veut dire quon a pas d'overflow
      if (this.limit >= 0) {
        //console.debug('--- on masque ---');
        this.inner.removeAttribute('data-bulb-cursor');
        gsap.set(this.progressWrap, {alpha: 0});
      } else {
        //console.debug('--- on affiche ---');
        gsap.set(this.progressWrap, {alpha: 1});
        this.inner.setAttribute('data-bulb-cursor', 'drag');
      }
    }
  }

  displayControls(){
    if (window.innerWidth === this.innerWidth){
      this.navButtons.classList.add('hideSliderButton')
    }else{
      this.navButtons.classList.remove('hideSliderButton')
    }
  }

  // bind all events
  bindEvents()
  {
    this.hammer = new window.Hammer(this.inner);
    window.addEventListener('resize',this.setup.bind(this))
    this.hammer.on('panstart',this.start.bind(this))
    this.hammer.on('panmove',this.move.bind(this))
    this.hammer.on('panend',this.end.bind(this))

    if (this.progressBar !== null) {
      this.hammerIndicator = new window.Hammer(this.progressBar);
      this.hammerIndicator.on('panstart',this.startIndicator.bind(this))
      this.hammerIndicator.on('panmove',this.moveIndicator.bind(this))
      this.hammerIndicator.on('panend',this.endIndicator.bind(this))
    }
  }

  // init & display total length of slide
  index()
  {
    this.total.innerHTML = `${this.slide.length}`
  }



  //debounce detecte slide
  // slide detection & update
  detectSlide()
  {
    let currentIndex = Math.round((this.dragSlidePercent * this.slide.length) / 100);
    if (currentIndex === 0 || isNaN(currentIndex)) {
      currentIndex = 1
    }
    this.displayCurrentIndex.innerHTML = currentIndex
  }

  // start pan for indicator
  startIndicator(e)
  {
    this.indicatorState = true
    this.StartIndicatorX = e.srcEvent.pageX - this.indicatorTranslate
  }
  // when indicator is moving
  moveIndicator(e)
  {
    const x = e.srcEvent.pageX
    const diffX = x - this.StartIndicatorX;
    this.indicatorTranslate =  diffX

    /** Condition  limit **/
    if (this.indicatorTranslate >= this.limitIndicator) {
      this.indicatorTranslate = this.limitIndicator
      if (this.indicatorTranslate <= 0) {
        this.indicatorTranslate = 0

        // calculate percentage
        this.dragIndicatorPercent = (this.indicatorTranslate *100) / this.limitIndicator
        // apply percentage of drag on slider movement when indicator is moving
        this.sliderTranslate  = this.dragIndicatorPercent * this.limit / 100
      }
    }
  }

  // end indicator --> can be remove
  endIndicator()
  {
    this.indicatorState = false
  }

// start pan for drag slider
  start(e)
  {
    this.startX = e.srcEvent.pageX - this.sliderTranslate
    //console.log("🥶start pan🥶")
  }

  // when drag slider is moving
  move(e){

    //console.log('💩😂💩')

    let moveX = (this.lastDeltaX - e.deltaX) * this.el.opts.scrollSpeed

    // const x = e.srcEvent.pageX
    // const diffX = x - this.startX;

    this.sliderTranslate  =  this.sliderTranslate - moveX

    // stock delta pour calculer sa différence
    this.lastDeltaX = e.deltaX


    // limit condition
    if (this.sliderTranslate  <= this.limit) this.sliderTranslate  = this.limit
    if (this.sliderTranslate  >= 0) this.sliderTranslate  = 0

    // calculate percentage
    this.dragSlidePercent = (this.sliderTranslate  *100) / this.limit


    // if draggable bar option is : true --> apply percentage of drag on indicator when slider is moving
    if (this.el.opts.draggableBar) {
      this.indicatorTranslate = this.dragSlidePercent * this.limitIndicator / 100
    }

    if (this.el.opts.getSlide){
      this.debouncedHandleMove()
    }

  }

  moveTo(direction)
  {
    let value = this.itemWidth

    if(direction === 'left') {
      this.sliderTranslate += value;
    } else {
      this.sliderTranslate -= value;
    }

    if (this.sliderTranslate  <= this.limit) this.sliderTranslate  = this.limit
    if (this.sliderTranslate  >= 0) this.sliderTranslate  = 0
    this.debounceLimiter()
    this.innerX += (this.sliderTranslate - this.innerX) * 0.1;
    this.innerSetterX(this.innerX);
  }

  checkLimitSlider() {
    if(this.el.opts.arrowBtnDirection)  {
      if(this.sliderTranslate  <= this.limit && !this.isLimitSlidePercent) {
        emitter.emit('dragSlider::limit', this.el, 'right');
        this.isLimitSlidePercent = true
      } else if(this.sliderTranslate  >= 0 && !this.isLimitSlidePercent) {
        emitter.emit('dragSlider::limit', this.el, 'left');
        this.isLimitSlidePercent = true
      } else {
        emitter.emit('dragSlider::noLimit', this.el);
        this.isLimitSlidePercent = false
      }
    }
  }

  end()
  {
    this.lastDeltaX = 0
  }


  // update position w/ inertia controled by gsap --> inertia value is modifiable w/ opts parameters
  update()
  {

    if (!this.stopped) {
      // on va opti les tween pour faire un quicksetter avec une inertie manuelle
      const dt = 0.1;

      //console.log("🚀🚀🚀🚀️")

      // moove sur le inner (la partie slidée)
      // pour éviter le changement infini a cause de la déccélération, on ajoute une fin
      if (Math.abs(this.innerX - this.sliderTranslate) > .5) {
        this.innerX += (this.sliderTranslate -  this.innerX) * dt;
        this.debounceLimiter()
        this.innerSetterX(this.innerX);
      } else {
        this.innerSetterX(this.sliderTranslate);
      }

      // moove sur la progress bar
      // pour éviter le changement infini a cause de la déccélération, on ajoute une fin
      if (Math.abs(this.progressBarX - this.indicatorTranslate) > .5) {
        this.progressBarX += (this.indicatorTranslate - this.progressBarX) * dt;
        this.progressBarSetterX(this.progressBarX);
      } else {
        this.progressBarSetterX(this.indicatorTranslate);
      }

      this.rafId =  requestAnimationFrame(this.update.bind(this))
    }


  }

  play()
  {
    //console.log('play event --> play slider', this)
    this.stopped = false;
    this.update()
  }

  pause()
  {
    //console.log('pause event --> pause slider', this)
    this.stopped = true;
    cancelAnimationFrame(this.rafId)
  }

  destroy()
  {
    //console.log('destroy event --> drag slider')
    cancelAnimationFrame(this.rafId)

    this.hammer.off('panstart')
    this.hammer.off('panmove')
    this.hammer.off('panend')
    this.hammerIndicator.off('panstart')
    this.hammerIndicator.off('panmove')
    this.hammerIndicator.off('panend')
  }

}



// WEBPACK FOOTER //
// ./scripts/utils/components/dragSlider.js